import { Alert, Button, Stack, Text } from '@chakra-ui/react'

import {
  pendingKeepLabel,
  pendingPlanChangeDetail,
  pendingPlanChangeHeadline,
  type PendingPlanChange,
} from './planChange'

export type PendingPlanChangeBannerProps = {
  pending: PendingPlanChange
  /** Removes the scheduled change. Omit to show the notice without the action. */
  onKeep?: () => void
  keeping?: boolean
  error?: string | null
}

/**
 * "Switching to Startups Pro on {date}" with **Keep Team**, or for a term downgrade (L57)
 * "Switching to monthly billing on {date}" with **Keep current plan**, on Plans and the billing
 * page. The member keeps their current plan until then; nothing is charged or credited now.
 */
export const PendingPlanChangeBanner = ({
  error,
  keeping,
  onKeep,
  pending,
}: PendingPlanChangeBannerProps) => {
  return (
    <Stack gap={2} w={'full'}>
      <Alert.Root alignItems={{ base: 'start', sm: 'center' }} status={'info'} variant={'surface'}>
        <Alert.Indicator />
        <Alert.Content>
          <Alert.Title>{pendingPlanChangeHeadline(pending)}</Alert.Title>
          <Alert.Description>
            <Text textStyle={'sm'}>{pendingPlanChangeDetail(pending)}</Text>
          </Alert.Description>
        </Alert.Content>
        {onKeep ? (
          <Button flexShrink={0} loading={keeping} size={'sm'} variant={'outline'} onClick={onKeep}>
            {pendingKeepLabel(pending)}
          </Button>
        ) : null}
      </Alert.Root>
      {error ? (
        <Alert.Root status={'error'}>
          <Alert.Indicator />
          <Text textStyle={'sm'}>{error}</Text>
        </Alert.Root>
      ) : null}
    </Stack>
  )
}
